export default "__VITE_ASSET__BKOITo8e__"